import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  operation: 'find',
  database: '',
  collection: '',
  query: '{}',
  document: '{}',
  updateData: '{}',
  pipeline: '[]',
  limit: 100,
  // New operation defaults
  sourceArray: '',
  dropIfExists: false,
};

export default defaults;
